var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6895 5.69141C5.18945 5.69141 2.18945 12.4414 2.18945 12.4414C2.18945 12.4414 5.18945 19.1914 12.6895 19.1914C20.1895 19.1914 23.1895 12.4414 23.1895 12.4414C23.1895 12.4414 20.1895 5.69141 12.6895 5.69141Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6895 16.1914C14.7605 16.1914 16.4395 14.5125 16.4395 12.4414C16.4395 10.3703 14.7605 8.69141 12.6895 8.69141C10.6184 8.69141 8.93945 10.3703 8.93945 12.4414C8.93945 14.5125 10.6184 16.1914 12.6895 16.1914Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.d9eba76a5b43b92af90888dcb63490c7.svg";
export { ForwardRef as ReactComponent };